import { FaIcon } from '@components/FaIcon';
import { ComboField } from '@components/Fields/ComboField';
import { Fieldset } from '@components/Fields/Fieldset';
import { FloatField } from '@components/Fields/FloatField';
import { StringField } from '@components/Fields/StringField';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { VerticalGrid } from '@components/VerticalGrid';
import { IForm } from '@hooks/useForm';
import { IClienteSaldo } from '@model/ClienteSaldo';
import { IComboEmpresa } from '@model/Empresa';
import { EnumTipoSaldo } from '@services/ClienteService';
import React from 'react';

export type SaldoRegistrarFormProps = {
    form: IForm<Partial<IClienteSaldo>>
    empresaCombo: IComboEmpresa
    tipo: EnumTipoSaldo
}

export function SaldoRegistrarForm ({ form, empresaCombo, tipo }: SaldoRegistrarFormProps) {
    const { fields } = form;

    const title = React.useMemo(() => tipo === EnumTipoSaldo.Debito ? "Dados do Débito" :  "Dados do Crédito", [tipo]);

    return (
        <VerticalGrid>
            <Fieldset
                title={title}
                icon={<FaIcon icon="fa-solid fa-file-invoice-dollar" />}
                hasMarginTop={false}
            >
                <HorizontalGrid spacing={1}>
                    <GridItem xs={2}>
                        <ComboField 
                            field={fields.empresaId}
                            label="Empresa"
                            required
                        >
                            {empresaCombo.createOptions()}
                        </ComboField>
                    </GridItem>

                    <GridItem xs={9}>
                        <StringField
                            field={fields.descricao}
                            label="Descrição"
                            required
                        />
                    </GridItem>

                    <GridItem xs={1}>
                        <FloatField
                            field={fields.valor}
                            label="Valor"
                            required
                        />
                    </GridItem>
                </HorizontalGrid>
            </Fieldset>
        </VerticalGrid>
    )
}